// extracted by mini-css-extract-plugin
export default {"container":"Radio_container__TkA+o","label":"Radio_label__zRzXJ","containerReverse":"Radio_containerReverse__9I4eD","radioContainer":"Radio_radioContainer__vA4X-"};